<template>
  <div class="withdraw_info_wrapper">
    <div class="short_cut">
      <div>
        <div class="wrapper_img">
          <img src="@/assets/images/img_coin.svg" alt="coin" :class="{ img_coin: pointInfo.njPointEnable }" />
          <img src="@/assets/images/img_exchange.svg" alt="exchange" class="img_exchange" />
          <img
            v-if="pointInfo.njPointEnable"
            src="@/assets/images/img_money_with_point.svg"
            alt="money_with_point"
            class="img_money_point"
          />
          <img v-else src="@/assets/images/img_money.svg" alt="money" />
        </div>
        <h1 class="h1" v-html="mainText" />
        <p class="sub_text" v-html="$t('global.subText')" />
      </div>
    </div>
    <div v-if="withdrawPolicy" class="withdraw_rule">
      <Viewer :key="withdrawPolicy" :initialValue="withdrawPolicy" />
    </div>
    <div v-if="withdrawNotice" class="withdraw_info">
      <h3 class="h3">{{ $t('global.applyGuide') }}</h3>
      <Viewer :key="withdrawNotice" :initialValue="withdrawNotice" />
    </div>
    <div v-if="pointInfo.njPointEnable && njPointWithdrawNotice" class="withdraw_info">
      <h3 class="h3">{{ $t('global.applyGuidePoint') }}</h3>
      <Viewer :key="njPointWithdrawNotice" :initialValue="njPointWithdrawNotice" />
    </div>
    <div class="wrapper_button">
      <button class="btn btn01" @click="handleRequestWithdraw" ref="btn">
        {{ $t('global.applyBtn') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { exchangeApi } from '@/api';
import { checkUserRegion } from '@/utils';
import { Viewer } from '@toast-ui/vue-editor';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import mixin from '@/utils/mixin';
import WithdrawModal from '@/components/modules/globalWithdraw/WithdrawModal';
import { validateGlobalWithdraw } from '@/utils/globalWithdrawValidation';

export default {
  mixins: [mixin],
  components: {
    Viewer,
  },
  data() {
    return {
      withdrawPolicy: '',
      withdrawNotice: '',
      njPointWithdrawNotice: '',
    };
  },
  created() {
    this.init();
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.init();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('exchange', ['exchangeCurrency']),
    ...mapGetters('point', ['pointInfo']),
    mainText() {
      return this.pointInfo.njPointEnable ? this.$t('global.mainTextForNexonPoint') : this.$t('global.mainText');
    },
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('point', ['getPointInfo']),
    ...mapActions('exchange', ['getExchangeInfo', 'checkGlobalExchange', 'setIsNjPointWithdraw']),
    async init() {
      this.setIsNjPointWithdraw(false);
      await this.getPointInfo();
      await this.getExchangeInfo();

      const withdrawDataResponse = await exchangeApi.getGlobalNotice();
      const { data } = withdrawDataResponse;
      const { withdrawPolicy, withdrawNotice, njPointWithdrawNotice } = data.data;

      this.withdrawPolicy = this.$sanitize(withdrawPolicy);
      this.withdrawNotice = this.$sanitize(withdrawNotice);
      this.njPointWithdrawNotice = this.$sanitize(njPointWithdrawNotice);
    },
    async handleRequestWithdraw() {
      // krpc 유저인 경우 한국 출금 팝업 오픈
      if (checkUserRegion() === 'krpc') {
        this.openModal({
          type: 'alert',
          message: this.$t('global.notAvailableCurrency'),
        });
        return;
      }

      // 글로벌 유저인 경우
      // nj 포인트 출금 가능한 경우 출금유형 선택 팝업 오픈
      if (this.pointInfo.njPointEnable) {
        this.openModal({
          type: 'data',
          header: this.$t('global.modalHeader'),
          message: '',
          component: WithdrawModal,
        });
        return;
      }

      // 기존 글로벌 출금 flow 진행행
      const { code } = await this.checkGlobalExchange();

      if (code !== 0) {
        const { unit } = this.pointInfo;
        const { exchangeMinAmount, exchangeMaxAmount } = this.exchangeCurrency;
        validateGlobalWithdraw({ code, unit, exchangeMinAmount, exchangeMaxAmount });
        return;
      }

      this.$router.push({
        name: 'GlobalWithdrawForm',
        query: {
          ...this.$route.query,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.h1 {
  font-weight: 700;
  font-size: 22px;
  line-height: 30px;
  color: #111111;
  text-align: center;
  font-family: 'NEXONLv1Gothic';
}
.h2 {
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #050c42;
  font-family: 'NEXONLv1Gothic';
}
.withdraw_info_wrapper {
  padding-top: 25px;
}
.short_cut {
  display: flex;
  justify-content: center;
  margin-bottom: 35px;
  .wrapper_img {
    height: 85px;
    margin-bottom: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img_exchange {
    width: 40px;
    height: 34px;
    display: flex;
    align-items: center;
    margin: 25.5px 32px;
  }
  .img_money_point {
    width: 126px;
    height: 92px;
  }
  .sub_text {
    margin-top: 10px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #666666;
  }
}
.withdraw_info {
  margin-top: 30px;
  font-family: 'Malgun Gothic';
  color: #666;
  > .h3 {
    margin-bottom: 12px;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
  }
}

.wrapper_button {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

@media all and (max-width: 768px) {
  .h2 {
    margin-left: 15px;
  }
  ::v-deep span {
    display: block;
  }
  .short_cut {
    .img_exchange {
      margin: 25.5px 22px;
    }
  }
}

@media all and (max-width: 480px) {
  h1 {
    font-size: 20px;
    line-height: 30px;
  }
  .short_cut {
    .sub_text {
      font-size: 12px;
      line-height: 20px;
    }
    .img_coin {
      width: 62px;
      height: 62px;
    }
    .img_money_point {
      width: 111px;
      height: 80px;
    }
  }
  button {
    width: 100%;
  }
}
</style>
